<template>
    <div class="container" v-if="show">
        <div class="row">
            <div class="col-md-2 text-center title-row">
                <div class="sticky">
                    <h2 class="page-title">{{title}}</h2>
                    <div class="description small">
                        {{description}}
                    </div>
                </div>
            </div>
            <div class="col-md-10">
                <div class="sticky">
                    <page :last_page="books.last_page" v-model="page" @goto="goto"></page>
                </div>
                <div v-if="books.total" class="results">
                    <div v-for="b in books.data" :key="b.id">
                        <book-card :book="b" :author="true" :favorite="false" @updated="load()"></book-card>
                        <headline :book="b"></headline>
                    </div>
                </div>
                <div v-else class="my-5">
                    小説がありません。
                </div>
            </div>
        </div>
        <loading
            v-model:active="isLoading"
            :can-cancel="false"
            :is-full-page="true"></loading>
    </div>
</template>

<style scoped>
.title-row {
    padding-top: 3.2rem;
}
.page-title {
    font-size: 1.9rem;
    color: #1b44c1;
    padding-top: 1rem;
}
</style>

<script>
import page from "components/Page";
import bookCard from "pages/author/bookCard";
import headline from "./headline"
export default {
    components: {
        bookCard,
        page,
        headline,
    },
    data() {
        return {
            page: parseInt(this.$route.query.page) || 1,
            books: {},
            isLoading: false,
            show: false,
        }
    },
    methods: {
        goto(n) {
            this.$router.push({
                query: {page: n}
            }).catch(err => {});
        },
        load() {
            this.isLoading = true;
            this.page = parseInt(this.$route.query.page) || 1;
            axios.get("/novels/get", {params: {
                page: this.page,
                sort: this.$route.params.sort
            }}).then(res => {
                this.books = res.data;
                this.show = true;
            }).catch(err => {
                alert.err(err.response);
            }).finally(() => {
                this.isLoading = false;
            });
        },
        makeHead() {
            this.useHead({
                title: this.title + " | 貸し本棚",
                link: [ { rel: "canonical", href: location.origin + location.pathname, id: "canonical" } ]
            });
        }
    },
    watch: {
        $route(n, o) {
            this.load();
        }
    },
    computed: {
        isRoot() {
            return this.$store.state?.user?.is_root;
        },
        title() {
            let title = "小説一覧";
            if (this.$route.params.sort === "long") {
                title = "長編小説";
            } else if (this.$route.params.sort === "news") {
                title = "新着小説";
            } else if (this.$route.params.sort === "updates") {
                title = "更新小説";
            } else if (this.$route.params.sort === "finishes") {
                title = "完結小説";
            } else if (this.$route.params.sort === "short") {
                title = "短編小説";
            } else if (this.$route.params.sort === "r18") {
                title = "R18小説";
            } else if (this.$route.params.sort === "xxx") {
                title = "XXX小説";
            }
            return title;
        },
        description() {
            let desc = "小説一覧";
            if (this.$route.params.sort === "long") {
                desc = "長編小説のおすすめ順。";
            } else if (this.$route.params.sort === "news") {
                desc = "初回公開順で、短編を含みます。";
            } else if (this.$route.params.sort === "updates") {
                desc = "長編小説の更新順で、公開後に更新された作品です。";
            } else if (this.$route.params.sort === "finishes") {
                desc = "完結小説の更新順です。電子書籍を出力できます。";
            } else if (this.$route.params.sort === "short") {
                desc = "短編小説のおすすめ順。";
            } else if (this.$route.params.sort === "r18") {
                desc = "R18小説のおすすめ順で、短編を含みます。";
            } else if (this.$route.params.sort === "xxx") {
                desc = "XXX小説のおすすめ順で、短編を含みます。";
            }
            return desc;
        }
    },
    mounted() {
        this.load();
        this.makeHead();
    }
}
</script>